"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_core_1 = require("@patternfly/react-core");
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const ModalProgress = ({ error, progress }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (React.createElement(react_core_1.Stack, { hasGutter: true },
        error && (React.createElement(react_core_1.StackItem, null,
            React.createElement(react_core_1.Alert, { variant: react_core_1.AlertVariant.danger, title: error.title, isInline: true }, error.message))),
        progress !== null && (React.createElement(react_core_1.StackItem, null,
            React.createElement(react_core_1.Progress, { value: progress, measureLocation: react_core_1.ProgressMeasureLocation.outside, "aria-label": t('ai:Progress') })))));
};
exports.default = ModalProgress;
//# sourceMappingURL=ModalProgress.js.map